import type { SVGProps } from 'react';

const GiveCoins = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.83334 12.836H3.16667V8.50266H4.83334V9.83599M4.83334 12.836V9.83599M4.83334 12.836C9.33334 12.836 12.8333 10.6693 12.8333 10.6693V9.16932H8.83334M4.83334 9.83599L7.18667 8.58132C7.28309 8.52981 7.39069 8.50279 7.50001 8.50266H8.16667C8.34348 8.50266 8.51305 8.57289 8.63808 8.69792C8.7631 8.82294 8.83334 8.99251 8.83334 9.16932M8.83334 9.16932V10.0027L7.16667 10.836"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_1653_396)">
      <path
        d="M10.4306 4.57211V3.80822M13.3472 3.80822V4.91934C13.3472 5.03945 13.2166 5.14936 13 5.2342M13.3472 3.80822C13.3472 4.0767 12.6943 4.29434 11.8889 4.29434C11.0835 4.29434 10.4306 4.0767 10.4306 3.80822M13.3472 3.80822C13.3472 3.53975 12.6943 3.32211 11.8889 3.32211C11.0835 3.32211 10.4306 3.53975 10.4306 3.80822"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2361 5.75265V6.86376C12.2361 7.13224 11.5832 7.34987 10.7778 7.34987C9.97236 7.34987 9.31944 7.13224 9.31944 6.86376V5.75265M12.2361 5.75265C12.2361 6.02112 11.5832 6.23876 10.7778 6.23876C9.97236 6.23876 9.31944 6.02112 9.31944 5.75265M12.2361 5.75265C12.2361 5.48418 11.5832 5.26654 10.7778 5.26654C9.97236 5.26654 9.31944 5.48418 9.31944 5.75265"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1653_396">
        <rect
          width="6.66667"
          height="6.66667"
          fill="currentColor"
          transform="translate(8 2.00266)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default GiveCoins;
